module.exports = __webpack_public_path__ + "942dc101b6030dfcaa8a906e614fc223.png";